<template>
  <div class="ml-2 mx-4 mx-md-0">
    <div v-if="loading" class="loading">Loading...</div>
    <div v-if="!!myUserData && !loading">
      <h4 class="mb-2 mt-2">
        {{ $t("editar perfil") }}:
        <country-flag
          class="float-right pr-0"
          :country="paisCode(myUserData.nationality)"
          size="big"
        ></country-flag>
      </h4>
      <p class="mb-4">{{ $t("texto_edite_datos") }}:</p>
      <div class>
        <form @submit.prevent="actDatosUser" v-if="myUserData">
          <h5>
            {{ $t("informacion personal") }}:
            <button
              type="submit"
              data-toggle="tooltip"
              data-placement="top"
              class="btn btn-sm btn-success mt-2 float-right pt-2 pb-2 btn-w"
            >
              {{ $t("guardar cambios") }}
            </button>
          </h5>

          <div class="row">
            <div class="col-md-12">
              <label class="font-weight-normal">
                {{ $t("nombre") }}
                <span class="required">*</span>
              </label>
              <input
                type="text"
                class="woocommerce-Input woocommerce-Input--text input-text"
                v-model="myUserData.name"
              />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-12">
              <label class="font-weight-normal">
                {{ $t("apellidos") }}
                <span class="required">*</span>
              </label>
              <input
                type="text"
                class="woocommerce-Input woocommerce-Input--text input-text"
                v-model="myUserData.lastname"
              />
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <label class="font-weight-normal">
                {{ $t("dni_nif_pasaporte") }}
                <span class="required">*</span>
              </label>
              <input
                type="text"
                class="woocommerce-Input woocommerce-Input--text input-text"
                v-model="myUserData.dni"
              />
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <label class="font-weight-normal">
                {{ $t("nacionalidad") }}
                <span class="required">*</span>
              </label>

              <select class="form-control" v-model="myUserData.nationality">
                <option
                  v-for="pais in countries"
                  v-bind:key="pais.id"
                  v-bind:value="pais.id"
                  >{{
                    pais.name
                      | filterTranslateCountry(
                        pais.id,
                        pais.translations,
                        $i18n.locale
                      )
                  }}</option
                >
              </select>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <label class="font-weight-normal"
                >{{ $t("email") }}: <b>{{ myUserData.email }}</b></label
              >
            </div>
            <!-- MODIFICAR EMAIL -->
            <div class="col-md-12">
              <button
                @click="showNewMail = !showNewMail"
                type="button"
                class="btn btn-primary btn-lg btn-block mt-1 btn-sm"
                :class="{ 'btn-warning': showNewMail }"
              >
                {{ showNewMail ? $t("cancelar") : $t("modificar email") }}
              </button>
            </div>
          </div>

          <div class="row" v-if="showNewMail">
            <div class="col-12">
              <div class="card text-left">
                <div class="card-body">
                  <h4 class=" h5 card-title text-center">
                    {{ $t("modificar email") }}
                  </h4>
                  <div class="row ">
                    <div class="col-md-12">
                      <user-new-mail
                        @emitCerrar="showNewMail = false"
                        :currentMail="myUserData.email"
                      ></user-new-mail>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />

          <!-- teléfonos form -->
          <p class="mt-2">
            {{ $tc("telefono", 2) }} ({{ contadorPhones }})
            <transition name="fade">
              <button
                v-if="!newPhone"
                class="btn btn-sm btn-outline-success mt-2 float-right pt-2 pb-2 btn-w"
                role="button"
                @click.prevent="newPhoneShowComp"
              >
                {{ $t("agregar") }}
                <i class="fa fa-plus"></i>
              </button>
            </transition>
          </p>
          <transition name="fade">
            <user-phone-new
              v-if="newPhone || editarTelefono.mostrarComp"
              :countries="countries"
              :newPhone="newPhone"
              :editPhone="editarTelefono.data"
              @newPhoneShowEmit="newPhoneShowComp"
            ></user-phone-new>
          </transition>

          <hr />

          <div v-if="!isLoading">
            <div v-for="phone in myPhones" :key="phone.id">
              <user-phone
                :phone="phone"
                :countries="countries"
                @emitEditarTel="editarTel(phone)"
                @emitEliminarTel="eliminarTel"
              ></user-phone>
            </div>
          </div>

          <hr />

          <!-- direcciones -->
          <p v-if="!isLoading">
            {{ $tc("direccion", 2) }} ({{ contadorAdresses }})
            <transition name="fade">
              <button
                v-if="editingAddress === false && newAddress === false"
                class="btn btn-sm btn-outline-success mt-2 float-right pt-2 pb-2 btn-w"
                role="button"
                @click.prevent="newAddressShowComp"
              >
                {{ $t("agregar") }}
                <i class="fa fa-plus"></i>
              </button>
            </transition>
          </p>

          <transition name="fade">
            <user-address-form
              v-if="editingAddress === true || newAddress === true"
              :countries="countries"
              :addressId="addressEditId"
              @finishEditAddress="finishEditAddress"
            ></user-address-form>
          </transition>

          <div class="row">
            <div
              class="col-md-6"
              v-for="(address, index) in myUserData.addresses"
              :key="address.id"
            >
              <user-addresses-card
                :editando="editingAddress"
                :indexEditing="indexEditing"
                :index="index"
                :address="address"
                @editAddress="editAddress($event)"
              ></user-addresses-card>
            </div>
          </div>

          <p></p>
          <div class="clear mb-5"></div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import UserPhone from "./User-phone-edit.vue";
import UserPhoneNew from "./User-phone-new.vue";
import UserAddressForm from "./User-address-form";
import UserAddressesCard from "./User-addresses-card";
import UserNewMail from "./User-New-Mail";
import CountryFlag from "vue-country-flag";

export default {
  name: "User-edit",

  components: {
    UserPhone,
    UserPhoneNew,
    UserAddressesCard,
    UserAddressForm,
    UserNewMail,
    CountryFlag
  },
  data() {
    return {
      isLoading: true,
      newPhone: false,
      newAddress: false,
      editingAddress: false,
      indexEditing: -1,
      addressEditId: -1,
      showNewMail: false,
      myUserData1: null,

      editarTelefono: {
        mostrarComp: false,
        data: null
      }
    };
  },

  computed: {
    ...mapState("account", [
      "status",
      "user",
      "countries",
      "userData",
      "loading"
    ]),
    ...mapState("usuario", ["current"]),
    contadorPhones() {
      return Object.keys(this.myUserData.phones).length;
    },
    contadorAdresses() {
      return Object.keys(this.myUserData.addresses).length;
    },
    myUserData() {
      return _.cloneDeep(this.myUserData1);
    },
    myPhones() {
      if (!this.myUserData1) return [];
      return this.myUserData1.phones;
    }
  },
  methods: {
    ...mapActions("usuario", ["updateUser"]),
    ...mapActions("account", ["refreshUserData"]),
    ...mapActions("phone", ["deleteUserPhone"]),
    /* funcion para pedir los datos de usuario a la api */
    refrescarDatos() {
      this.isLoading = true;
      this.refreshUserData().then(res => {
       // console.log(res);
        this.myUserData1 = JSON.parse(JSON.stringify(res));
        this.isLoading = false;
      });
    },

    /* funcion para editar un telefono */
    editarTel(datos) {
      this.editarTelefono.mostrarComp = true;
      this.editarTelefono.data = datos;
    },
    /* funcion para eliminar un telefono */
    eliminarTel(id) {
     this.deleteUserPhone(id).then(res => {
       this.refrescarDatos();
     })
      
    },
    /* actualizar los datos del usuario en la api */
    actDatosUser() {
      this.updateUser(this.myUserData);
    },
    /* componente telefono ocultar */
    newPhoneShowComp(refresh) {
     
      //si estoy editando y cancelo...
      if (this.editarTelefono.mostrarComp) {
        this.editarTelefono.mostrarComp = false;
        this.editarTelefono.data = null;
      } else {
        //si no edito cambio la visualización de form
        this.newPhone = !this.newPhone;
      }
      if (refresh) this.refrescarDatos();
      
    },
    /* formulario nueva direccion */
    newAddressShowComp() {
      this.newAddress = !this.newAddress;
    },
    /* formulario edicion direccion */
    editAddress(objAddress, indexEditing) {
      if (!this.editingAddress && !this.newAddress) {
        this.editingAddress = true;
        this.indexEditing = objAddress.index;
        this.addressEditId = objAddress.objAddress.id;
      }
    },
    /* cierre del formulario de direccion */
    finishEditAddress() {
      this.editingAddress = false;
      this.indexEditing = -1;
      this.addressEditId = -1;
      this.newAddress = false;
    },
    /* generar el cod d la bandera de un pais seleccionado */
    paisCode(id) {
      if (id === null) return "";
      const country = this.countries.find(c => c.id === id);
      if (!!country.iso) {
        return country.iso.toLowerCase();
      } else {
        return "";
      }
    }
  },
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        console.log("hay cambios", newValue, oldValue);
        if (!this.userData) return;
        setTimeout(() => {
          if (!this.userData) return;
          this.myUserData1 = newValue;
          Object.assign(this.myUserData, this.userData);
        }, 200);
      }
    }
  },
  mounted() {
    /* this.refreshUserData().then(res => {
      this.myUserData1 = JSON.parse(JSON.stringify(res));
      this.isLoading = false;
    }); */
    this.refrescarDatos();
  }
};
</script>
<style scoped>
>>> input,
>>> select {
  max-height: 35px;
  margin-left: 0px;
  background-color: #fff;
  border: 1px solid #ccc;
  padding-left: 5px;
}
>>> select {
  padding: 1px;
}
</style>
